<script setup>
import { computed } from 'vue'

const URL_PATTERN = /^https:\/\/(?:www\.)?calendar\.google\.com\/calendar\/(?:u\/\d+\/)?embed\?(?:[^#]*&)?src=.+/i

const props = defineProps({
	src: {
		type: String,
		default: null,
	},
})

const href = computed(() => {
	const value = (props.src || '').trim()

	return URL_PATTERN.test(value) ? value : null
})
</script>

<template>
	<div v-if="href" style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 75%">
		<iframe :src="href" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0" allowfullscreen></iframe>
	</div>
</template>
